import { FieldPath, FieldValues } from 'react-hook-form';

// common
import { IControllerRenderProps } from 'common/SchemaForm/utils';
import OperationCodeFieldBase from 'common/components/OperationCodeField/OperationCodeFieldBase';

interface Props<T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>>
  extends IControllerRenderProps<T, TName> {
  label?: React.ReactNode;
  required?: boolean;
}

const OperationCodeField = <
  T extends FieldValues = FieldValues,
  TName extends FieldPath<T> = FieldPath<T>,
>(
  props: Props<T, TName>
) => {
  const {
    label,
    field: { value },
    fieldState: { invalid },
    required = true,
  } = props;

  // static version always renders three segments, splitting on dash
  const parts = value ? value.split('-') : [];
  const displayParts = [parts[0] ?? '', parts[1] ?? '', parts[2] ?? ''];

  return (
    <OperationCodeFieldBase
      label={label}
      required={required}
      invalid={invalid}
      displayParts={displayParts}
    />
  );
};

export default OperationCodeField;
